import React from "react";

import ChipOnTable from "../../chip/chip-on-table";
import {BetType} from "../../../enums/tableNumbers";
import {toJS} from "mobx";

export const RectangleTableLeft = ({
                                     selectedData,
                                     allChipsTypes,
                                     ovalTableBetState,
                                     handleGetColumnChip,
                                     winNumber,
                                     isBetsClosed,
                                   }) => {
  const straightUp_0_Chip = handleGetColumnChip(BetType.StraightUp_0);
  const Street_0_1_2_Chip = handleGetColumnChip(BetType.Street_0_1_2);
  const Street_0_2_3_Chip = handleGetColumnChip(BetType.Street_0_2_3);
  const Corner_0_1_2_3_Chip = handleGetColumnChip(BetType.Corner_0_1_2_3);

  return (
    <div className="table-content-left">
      <div className={`main-game-cont-box ${winNumber === 0 ? 'win' : ''} ${!isBetsClosed && (ovalTableBetState || selectedData)?.includes(0) ? 'active' : ''}`}
           data={BetType.StraightUp_0}>
        <svg
          className="chart-left-arrow"
          id="Layer_1"
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 46.28 168.88"
        >
          <defs>
            <linearGradient
              id="linear-gradient-box"
              x1="23.14"
              y1="168.38"
              x2="23.14"
              y2="0.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop offset="0" stopColor="#003e02"/>
              <stop offset="1" stopColor="#007e51"/>
            </linearGradient>
          </defs>
          <path
            className="cls-7"
            d="M45.78.5H22.15a3.42,3.42,0,0,0-3.34,2.68L.9,82.77c-.07.31-.19.61-.24.93a9,9,0,0,0,.09,3.77L18.5,164.19a5.4,5.4,0,0,0,5.27,4.19h22Z"
          />
        </svg>
        <div className="r-click block-0_2_3" data={BetType.Street_0_2_3}>
          <ChipOnTable
            type={BetType.Street_0_2_3}
            columnChips={Street_0_2_3_Chip}
            allChipsTypes={allChipsTypes}
          />
        </div>
        <div className="r-click block-0_1_2" data={BetType.Street_0_1_2}>
          <ChipOnTable
            type={BetType.Street_0_1_2}
            columnChips={Street_0_1_2_Chip}
            allChipsTypes={allChipsTypes}
          />
        </div>
        <div className="r-click block-0_1" data={BetType.Corner_0_1_2_3}>
          <ChipOnTable
            type={BetType.Corner_0_1_2_3}
            columnChips={Corner_0_1_2_3_Chip}
            allChipsTypes={allChipsTypes}
          />
        </div>
        <ChipOnTable
          type={BetType.StraightUp_0}
          columnChips={straightUp_0_Chip}
          child={() => 0}
          allChipsTypes={allChipsTypes}
        />
      </div>
    </div>
  );
};
